/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForOciOkeCluster extends models.ServiceAccountNativeDetailsBaseForKubernetesClusterCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForOciOkeCluster");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForOciOkeCluster.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForOciOkeCluster>): ServiceAccountNativeDetailsForOciOkeCluster {
        let obj = Object.assign(new ServiceAccountNativeDetailsForOciOkeCluster(), model);
        ServiceAccountNativeDetailsForOciOkeCluster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForOciOkeCluster>): ServiceAccountNativeDetailsForOciOkeCluster {
        if (!model) return null;
        return ServiceAccountNativeDetailsForOciOkeCluster.newInstance(<ServiceAccountNativeDetailsForOciOkeCluster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForOciOkeCluster) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForOciOkeCluster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForOciOkeCluster): boolean {
        if (models.ServiceAccountNativeDetailsBaseForKubernetesClusterCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForOciOkeCluster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
